import icon1 from '../../../Assets/Icons/wireframe1.svg';
import icon2 from '../../../Assets/Icons/wireframe2.svg';
import icon3 from '../../../Assets/Icons/wireframe3.svg';

export const features = [
    {
        icon:icon1,
        title:"Zero Learning Curve",
        desc:"Choose element you need, and simple drag & drop in canvas.",
        color:"#F1EBFF",
    },
    {
        icon:icon2,
        title:"UI Components",
        desc:"Built-in UI controls and beautiful line icons and awesome templete.",
        color:"#ec63231a"
    },
    {
        icon:icon3,
        title:"Share with everyone",
        desc:"Share or present wireframes on the web, or via images.",
        color:"#ff4f5b31"
    }
]
